(function() {
  'use strict';
  angular.module('common')
  .factory('cursorPosition', [function() {
    return function getCursorPosition(element) {
      var pos = 0;
      if (document.selection) {
        element.focus ();
        var range = document.selection.createRange();
        range.moveStart ('character', -range.value.length);
        pos = range.text.length;
      }
      else if (element.selectionStart || element.selectionStart == '0')
        pos = element.selectionStart;
      return pos;
    };
  }]);
})();
